'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasValue = exports.hasValue = function hasValue(value) {
  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
};

var getRandomNumber = exports.getRandomNumber = function getRandomNumber() {
  return Math.floor(Math.random() * 0xFFFF);
};


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text-field/helpers.js
// module id = 3044
// module chunks = 4